/** Roles verified for the currently open panel only. */
export type WorkspaceAuthScope = {
  accountId: string;
  eventId?: string;
  isAccountManager: boolean;
  isEventManager: boolean;
};

export type AuthExtras = {
  isSuperManager: boolean;
  /**
   * Coarse: manager of *any* account. Not resource auth — prefer
   * `workspace` / membership fetches for authorization.
   */
  isAccountManager: boolean;
  /**
   * Coarse: manager of *any* event. Not resource auth — prefer
   * `workspace` / membership fetches for authorization.
   */
  isEventManager: boolean;
  /** Scoped roles for the active panel (set by the panel gate). */
  workspace?: WorkspaceAuthScope;
};

/** Merge login/refresh flags without dropping an active panel workspace. */
export const mergeAuthExtras = (
  current: AuthExtras | undefined,
  next: AuthExtras
): AuthExtras => ({
  ...next,
  workspace: next.workspace ?? current?.workspace,
});
